<template>
	<div class="full_page">
		<section class="page">
			<div class="box_wrap">
				<div class="box">
					<div class="text_area">
						<p class="title">
							{{ $t('rtr_development-development.text1') }}<br />
							{{ $t('rtr_development-development.text2') }}<br />
							<span class="fw_bold"
								>{{ $t('rtr_development-development.text3') }} API</span
							>
						</p>
						<button @click="gotoDevelop">
							{{ $t('rtr_development-development.text4') }}
						</button>
					</div>
				</div>
				<div class="box">
					<div class="img_area">
						<img
							src="@/assets/images/development/main_bg_01.png"
							alt="background image"
						/>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import '@/assets/css/development.css';
export default {
	name: 'Development',
	data() {
		return {};
	},
	methods: {
		gotoDevelop() {
			let route = this.$router.resolve({ name: 'develop-home' });
			window.open(route.href);
		},
	},
};
</script>
